// extracted by mini-css-extract-plugin
export var innerContentInnerPadding = "_7M8h7";
export var topAndBottomPaddingOnDesktop = "gr93y";
export var topAndBottomPaddingOnMobile = "cb2Ox";